<video-preview-player [layoutCfg]="producerOptions.backstageLayout" [bgImages]="bgImages" [isPreview]="true" [isProducer]="isProducer" [noStreamText]="helperText" [producerOptions]="producerOptions">

	<div [ngClass]="styles.previewPlayerHeader">
		<span flex="fill">
			{{ 'Event_Producer_Preview' | translate }}
		</span>

		<audio-presenters [layout]="producerOptions.backstageLayout" [canEdit]="isProducer">
		</audio-presenters>
	</div>

	<button type="button" vbBtnSecondary [ngClass]="styles.sendLiveBtn" *ngIf="isProducer" [disabled]="sendLiveDisabled" (click)="sendVideoLive()" [tooltip]="'Event_Producer_SendLive' | translate" [delay]="1000" container="body" [attr.aria-label]="'Event_Producer_SendLive' | translate">
		<span class="glyphicons transfer"></span>
	</button>

</video-preview-player>
